<div class="dialog-content-wrapper">
    <mat-toolbar class="mat-primary m-0">
        <mat-toolbar-row
            fxFlex
            fxLayout="row"
            fxLayoutAlign="space-between center"
        >
            <span class="title dialog-title text-truncate"
                >Zonas de cobertura</span
            >
            <button
                mat-icon-button
                (click)="dialogRef.close()"
                aria-label="Close dialog"
            >
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <mat-dialog-content class="p-16 pb-0 m-0">
        <mat-form-field class="full-width">
            <mat-label>Región</mat-label>
            <mat-select
                required
                (selectionChange)="buscarComunasRegion($event)"
            >
                <mat-option
                    *ngFor="let region of data.regiones"
                    [value]="region.id"
                >
                    {{ region.nombre }}
                </mat-option>
            </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
            <mat-label>Comunas</mat-label>
            <mat-select [formControl]="comunas" multiple>
                <!-- mat-select-trigger>
                    {{ comunas.value ? comunas.value[0]?.nombre : "" }}

                    <span
                        *ngIf="comunas.value?.length > 1"
                        class="example-additional-selection"
                    >
                        (+{{ comunas.value.length - 1 }}
                        {{
                            comunas.value?.length === 2 ? "comuna" : "comunas"
                        }})
                    </span>
                </mat-select-trigger -->
                <mat-option
                    *ngFor="let comuna of listaComunas"
                    [value]="comuna"
                    >{{ comuna.nombre }}</mat-option
                >
            </mat-select>
        </mat-form-field>
    </mat-dialog-content>

    <mat-dialog-actions
        class="m-0 p-16"
        fxLayout="row"
        fxLayoutAlign="end center"
    >
        <button mat-button mat-dialog-close>Cancelar</button>
        <button
            mat-raised-button
            color="accent"
            (click)="guardar()"
            [disabled]="!comunas.value || comunas.value?.length === 0"
        >
            Guardar
        </button>
    </mat-dialog-actions>
</div>
